<template>
  <div class="growth container">
    <div class="content-1">
      <img class="bg" src="../assets/images/growth/bg_top.png" alt="">
      <div class="btn-join" @click="joinHandler()"></div>
    </div>
    <div class="content-2">
      <span class="title">推荐解决方案</span>
      <span class="notice">点击解决方案，与未来应用专家直接对话</span>
      <div class="list-case">
        <div class="item-case" @click="showDialogHandler(0)">
          <div class="content-name">
            <img class="bg-name" src="../assets/images/growth/bg_tool_title.png" alt="">
            <span class="name">获客增长解决方案</span>
          </div>
          <div class="content-core">
            <span class="name">核心优势</span>
            <div class="core-info">
              <span class="core">成本可控</span>
              <span class="core">按效果付费</span>
            </div>
          </div>
          <div class="content-tool">
            <span class="name">组合工具</span>
            <div class="tool-info">
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">增长工具</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">智能分析</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">流量创新</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">用户路径创新</span>
              </div>
            </div>
          </div>
          <div class="content-introduce">
            <img class="icon" src="../assets/images/growth/icon_link.png" alt="">
            <span class="introduce">产品介绍.PDF(4MB)</span>
          </div>
        </div>
        <div class="item-case" @click="showDialogHandler(1)">
          <div class="content-name">
            <img class="bg-name" src="../assets/images/growth/bg_tool_title.png" alt="">
            <span class="name">私域流量解决方案</span>
          </div>
          <div class="content-core">
            <span class="name">核心优势</span>
            <div class="core-info">
              <span class="core">裂变</span>
              <span class="core">转化率</span>
              <span class="core">商业设计</span>
            </div>
          </div>
          <div class="content-tool">
            <span class="name">组合工具</span>
            <div class="tool-info">
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">托管运营</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">留存方案</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">素材库</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">变现方案</span>
              </div>
            </div>
          </div>
          <div class="content-introduce">
            <img class="icon" src="../assets/images/growth/icon_link.png" alt="">
            <span class="introduce">产品介绍.PDF(25MB)</span>
          </div>
        </div>
        <div class="item-case" @click="showDialogHandler(2)">
          <div class="content-name">
            <img class="bg-name" src="../assets/images/growth/bg_tool_title.png" alt="">
            <span class="name">裂变传播解决方案</span>
          </div>
          <div class="content-core">
            <span class="name">核心优势</span>
            <div class="core-info">
              <span class="core">冷启动流量</span>
              <span class="core">裂变点</span>
            </div>
          </div>
          <div class="content-tool">
            <span class="name">组合工具</span>
            <div class="tool-info">
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">裂变工具</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">防封机制</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">社群/APP/H5/小程序</span>
              </div>
            </div>
          </div>
          <div class="content-introduce">
            <img class="icon" src="../assets/images/growth/icon_link.png" alt="">
            <span class="introduce">产品介绍.PDF(37MB)</span>
          </div>
        </div>
        <div class="item-case" @click="showDialogHandler(3)">
          <div class="content-name">
            <img class="bg-name" src="../assets/images/growth/bg_tool_title.png" alt="">
            <span class="name">销售分销解决方案</span>
          </div>
          <div class="content-core">
            <span class="name">核心优势</span>
            <div class="core-info">
              <span class="core">成本可控</span>
              <span class="core">按效果付费</span>
            </div>
          </div>
          <div class="content-tool">
            <span class="name">组合工具</span>
            <div class="tool-info">
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">转化率模型</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">效率工具</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">分销工具</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">分销用户</span>
              </div>
            </div>
          </div>
          <div class="content-introduce">
            <img class="icon" src="../assets/images/growth/icon_link.png" alt="">
            <span class="introduce">产品介绍.PDF(5MB)</span>
          </div>
        </div>
        <div class="item-case" @click="showDialogHandler(4)">
          <div class="content-name">
            <img class="bg-name" src="../assets/images/growth/bg_tool_title.png" alt="">
            <span class="name">门店留存解决方案</span>
          </div>
          <div class="content-core">
            <span class="name">核心优势</span>
            <div class="core-info">
              <span class="core">成本可控</span>
              <span class="core">按效果付费</span>
            </div>
          </div>
          <div class="content-tool">
            <span class="name">组合工具</span>
            <div class="tool-info">
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">小程序</span>
              </div>
              <div class="item-tool">
                <img class="icon" src="../assets/images/growth/icon_tool.png" alt="">
                <span class="tool">智能解决方案</span>
              </div>
            </div>
          </div>
          <div class="content-introduce">
            <img class="icon" src="../assets/images/growth/icon_link.png" alt="">
            <span class="introduce">产品介绍.PDF(5MB)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-3">
      <div class="title-info">
        <span class="title">有冷启动流量  苦于增长缓慢</span>
        <span class="title">产品没有热度没有曝光？</span>
      </div>
      <div class="content-desc">
        <span class="desc">如果您有流量、有粉丝、有用户，我们助你做裂变增长，围绕粉丝量、转发量、关注数、用户数、下载量、激活数、销售额、试用量等多个核心来设计营销闭环，实现裂变增长。</span>
      </div>
      <div class="list-features">
        <div class="item-feature" v-for="(item, index) in content2DescList1" :key="index">
          <img class="bg-feature" :src="item.bgImg" alt="">
          <div class="feature-info">
            <img class="icon" :src="item.icon" alt="">
            <span class="name" v-html="item.title"></span>
            <span class="desc" v-html="item.desc"></span>
          </div>
        </div>
      </div>
      <div class="title-info">
        <span class="title">有流量 没有渠道</span>
        <span class="title">不知道怎么传播 不懂何备份</span>
      </div>
      <div class="content-desc">
        <span class="desc">针对“新人”企业，全方位扶持，帮助你从0到1到百万的华丽蜕变</span>
      </div>
      <div class="list-features">
        <div class="item-feature" v-for="(item, index) in content2DescList2" :key="index">
          <img class="bg-feature" :src="item.bgImg" alt="">
          <div class="feature-info">
            <img class="icon" :src="item.icon" alt="">
            <span class="name" v-html="item.title"></span>
            <span class="desc" v-html="item.desc"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="content-4">
      <img class="top-bg" src="../assets/images/growth/bg_together.png" alt="">
      <span class="title">感受裂变传播的价值</span>
      <span class="notice">案例就是实力</span>
      <div class="swiper2">
        <div class="swiper-container" ref="swiper2">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-item" v-for="(item, index) in content3ExampleList" :key="index">
              <img class="bg" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-notice">
        <span class="name" v-text="content3ExampleList[swiper2CurrentIndex].title"></span>
        <span class="desc" v-text="content3ExampleList[swiper2CurrentIndex].desc">展示个性化的朋友圈</span>
        <div class="swiper-navs">
          <div
            class="item-nav"
            :class="{'selected':swiper2CurrentIndex===index}"
            v-for="(item, index) in content3ExampleList"
            :key="index"
            @click="changeSwiper2Handler(index)"
          ></div>
        </div>
      </div>
    </div>
    <div class="content-5">
      <div class="content-notice1">
        <img class="notice-bg1" src="../assets/images/growth/notice_bg1.png" alt="">
        <div class="list-notice">
          <span class="notice" v-for="(item, index) in content5TitleList1" :key="index" v-text="item"></span>
        </div>
      </div>
      <div class="swiper3">
        <div class="swiper-container" ref="swiper3">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-item" v-for="(item, index) in content5NameList1" :key="index">
              <img class="bg" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-notice">
        <span class="desc" v-text="content5NameList1[swiper3CurrentIndex].name"></span>
        <div class="swiper-navs">
          <div
            class="item-nav"
            :class="{'selected':swiper3CurrentIndex===index}"
            v-for="(item, index) in content5NameList1"
            :key="index"
            @click="changeSwiper3Handler(index)"
          ></div>
        </div>
      </div>
      <div class="content-notice2">
        <img class="notice-bg2" src="../assets/images/growth/notice_bg2.png" alt="">
        <div class="list-notice">
          <span class="notice" v-for="(item, index) in content5TitleList2" :key="index" v-text="item"></span>
        </div>
      </div>
      <div class="swiper4">
        <div class="swiper-container" ref="swiper4">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-item" v-for="(item, index) in content5NameList2" :key="index">
              <img class="bg" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-notice">
        <span class="desc" v-text="content5NameList2[swiper4CurrentIndex].name"></span>
        <div class="swiper-navs">
          <div
            class="item-nav"
            :class="{'selected':swiper4CurrentIndex===index}"
            v-for="(item, index) in content5NameList2"
            :key="index"
            @click="changeSwiper4Handler(index)"
          ></div>
        </div>
      </div>
      <div class="content-notice1">
        <img class="notice-bg2" src="../assets/images/growth/notice_bg2.png" alt="">
        <div class="list-notice">
          <span class="notice" v-for="(item, index) in content5TitleList2" :key="index" v-text="item"></span>
        </div>
      </div>
      <div class="swiper6">
        <div class="swiper-container" ref="swiper6">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-item" v-for="(item, index) in content5NameList3" :key="index">
              <img class="bg" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-notice">
        <span class="desc" v-text="content5NameList3[swiper6CurrentIndex].name"></span>
        <div class="swiper-navs">
          <div
            class="item-nav"
            :class="{'selected':swiper6CurrentIndex===index}"
            v-for="(item, index) in content5NameList3"
            :key="index"
            @click="changeSwiper6Handler(index)"
          ></div>
        </div>
      </div>
    </div>
    <div class="content-6">
      <div class="content-rocket">
        <img class="rocket" src="../assets/images/growth/bg_rocket.png" alt="">
      </div>
      <div class="swiper5">
        <div class="swiper-container" ref="swiper5">
          <div class="swiper-wrapper">
            <div class="swiper-slide slide-item" v-for="(item, index) in content6SwiperList" :key="index">
              <img class="bg" :src="item.img" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="content-brand">
        <span class="title">未来应用曾服务过超过3000+企业</span>
        <img class="bg-brand" src="../assets/images/growth/bg_brand.png" alt="">
      </div>
    </div>
    <div class="content-7">
      <div class="content-prize">
        <img class="bg-prize" src="../assets/images/growth/bg_prize.png" alt="">
        <!-- <span class="name">奖项</span>
        <span class="notice">行业认可</span> -->
      </div>
      <div class="content-person" id="contact">
        <img class="avatar" src="../assets/images/growth/contact_avatar.png" alt="">
        <div class="content-info">
          <div class="content-top">
            <div class="person-info">
              <span class="position">未来应用产品官</span>
              <span class="name">陈鸿</span>
              <span class="name-en">Chenhong</span>
            </div>
            <img class="icon" src="../assets/images/growth/icon_round.png" alt="">
          </div>
          <div class="content-bottom">
            <span class="notice">我是未来应用产品官陈鸿，</span>
            <span class="notice">感谢您看到这里，如果您想跟我聊</span>
            <span class="notice">聊，可以扫码加微信</span>
          </div>
        </div>
      </div>
      <div class="content-qr">
        <img class="qr" src="../assets/images/growth/qr_xiaoshimei.jpeg" alt="">
        <span class="phone-num" @click="callPhoneHandler(18518133416)">185 1813 3416</span>
        <span class="num">京ICP证110507号 | 京ICP备14036139号-15</span>
        <span class="company">Copyright© 2014 - 2018 by 北京流量源泉科技有限公司</span>
        <span class="company">All Rights Reserved</span>
      </div>
    </div>
    <div class="bg-dialog" v-if="showDialog" @click.stop="closeDialogHandler()">
      <div class="content-dialog" @click.stop="notDo()">
        <img class="icon-close" src="../assets/images/growth/icon_close.png" @click.stop="closeDialogHandler()" alt="">
        <div class="dialog-chat">
          <span class="title">{{dialogInfo.title}}</span>
          <span class="name">获取预约方案演示</span>
          <span class="desc">{{dialogInfo.desc}}</span>
          <div class="content-people">
            <img class="avatar" :src="dialogInfo.peopleAvatar" alt="">
            <div class="people-info">
              <span class="people-name">{{dialogInfo.peopleName}}</span>
              <span class="position">{{dialogInfo.peoplePosition}}</span>
              <span class="phone" @click="callPhoneHandler(dialogInfo.peoplePhone)">{{dialogInfo.peoplePhone}}</span>
            </div>
          </div>
          <div class="line"></div>
          <img class="qr-code" :src="dialogInfo.qr" alt="">
          <span class="notice">扫一扫二维码直接添加专家</span>
          <span class="notice">与专家在线交流</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Swiper from 'swiper'
export default {
  name: 'growth',
  components: {
    // HelloWorld
  },
  data () {
    return {
      showDialog: false,
      dialogInfo: {
        title: '私域流量解决方案',
        desc: '体验私域流量的价值',
        peopleName: '子萱',
        peopleAvatar: require('../assets/images/growth/avatar1.png'),
        peoplePosition: '未来应用 私域流量专家',
        peoplePhone: '电话：185 1813 3416',
        qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
      },
      contentDialogList: [
        {
          title: '让我们聊聊如何实现增长',
          desc: '私域流量+裂变增长',
          peopleName: 'sam',
          peopleAvatar: require('../assets/images/growth/avatar1.png'),
          peoplePosition: '未来应用 增长咨询负责人',
          peoplePhone: '电话：185 1813 3416',
          qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
        },
        {
          title: '私域流量解决方案',
          desc: '体验私域流量的价值',
          peopleName: '子萱',
          peopleAvatar: require('../assets/images/growth/avatar2.png'),
          peoplePosition: '未来应用 私域流量专家',
          peoplePhone: '电话：185 1813 3416',
          qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
        },
        {
          title: '裂变传播解决方案',
          desc: '抓住裂变红利',
          peopleName: '陈鸿',
          peopleAvatar: require('../assets/images/growth/avatar3.png'),
          peoplePosition: '未来应用 裂变增长专家',
          peoplePhone: '电话：185 1813 3416',
          qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
        },
        {
          title: '销量分销解决方案',
          desc: '让销售变简答',
          peopleName: '王旻',
          peopleAvatar: require('../assets/images/growth/avatar4.png'),
          peoplePosition: '未来应用 销售分销专家',
          peoplePhone: '电话：185 1813 3416',
          qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
        },
        {
          title: '门店留存解决方案',
          desc: '让门店升级',
          peopleName: 'kimmy',
          peopleAvatar: require('../assets/images/growth/avatar4.png'),
          peoplePosition: '未来应用 门店留存专家',
          peoplePhone: '电话：185 1813 3416',
          qr: require('../assets/images/growth/qr_xiaoshimei.jpeg')
        }
      ],
      swiper1: {},
      swiper2: {},
      swiper3: {},
      swiper4: {},
      swiper5: {},
      swiper6: {},
      swiper1CurrentIndex: 0,
      swiper2CurrentIndex: 0,
      swiper3CurrentIndex: 0,
      swiper4CurrentIndex: 0,
      swiper5CurrentIndex: 0,
      swiper6CurrentIndex: 0,
      content1Banners: [
        { title: '裂变刷屏', desc: '12亿的PV' },
        { title: '转化率引擎', desc: '800%的留存率提升' },
        { title: '销售裂变增长', desc: '高至1:10的ROI' },
        { title: 'AI优化成本效率', desc: '被重新定义的营销' }
      ], // banner
      content2DescList1: [
        { title: '模型', desc: '搭建闭环流量增长模型<br/>验证商业模式', bgImg: require('../assets/images/growth/list1_bg1.png'), icon: require('../assets/images/growth/list1_icon1.png') },
        { title: '工具', desc: '定制营销工具，实现<br/>效率倍增', bgImg: require('../assets/images/growth/list1_bg2.png'), icon: require('../assets/images/growth/list1_icon2.png') },
        { title: '技术', desc: '公司的技术留着做产品<br/>营销的技术就交给我们吧', bgImg: require('../assets/images/growth/list1_bg3.png'), icon: require('../assets/images/growth/list1_icon3.png') },
        { title: '风控', desc: '防羊毛，防黑产<br/>在规则和技术上堵住漏洞<br/>为营销活动护航', bgImg: require('../assets/images/growth/list1_bg4.png'), icon: require('../assets/images/growth/list1_icon4.png') }
      ],
      content2DescList2: [
        { title: '流量', desc: '提供冷启动流量', bgImg: require('../assets/images/growth/list2_bg1.png'), icon: require('../assets/images/growth/list2_icon1.png') },
        { title: '渠道', desc: '非付费推广的渠道', bgImg: require('../assets/images/growth/list2_bg2.png'), icon: require('../assets/images/growth/list2_icon2.png') },
        { title: '社群', desc: '降低成本与提升效率', bgImg: require('../assets/images/growth/list2_bg3.png'), icon: require('../assets/images/growth/list2_icon3.png') },
        { title: '换量', desc: '小程序、公众号、APP', bgImg: require('../assets/images/growth/list2_bg4.png'), icon: require('../assets/images/growth/list2_icon4.png') }
      ],
      content3ExampleList: [
        {
          title: '摩登天空：草莓音乐节',
          desc: '展示个性化的朋友圈',
          img: require('../assets/images/growth/swiper2_bg1.png')
        },
        {
          title: '支付宝：十年账单',
          desc: '人人都玩过的账单',
          img: require('../assets/images/growth/swiper2_bg2.png')
        },
        {
          title: '人民日报：穿上军装照',
          desc: '上线第二天访问量破亿',
          img: require('../assets/images/growth/swiper2_bg3.png')
        },
        {
          title: '网易：有态度',
          desc: '打造精品内容传播',
          img: require('../assets/images/growth/swiper2_bg4.png')
        },
        {
          title: '浦发银行：我说话的时候，请不要戳我',
          desc: '打造精品内容传播',
          img: require('../assets/images/growth/swiper2_bg5.png')
        }
      ],
      content4DescList: [
        {
          name: '双屏互动',
          img: require('../assets/images/growth/list3_icon1.png')
        },
        {
          name: 'AI图像识别',
          img: require('../assets/images/growth/list3_icon2.png')
        },
        {
          name: '指纹识别',
          img: require('../assets/images/growth/list3_icon3.png')
        },
        {
          name: '粒子效果',
          img: require('../assets/images/growth/list3_icon4.png')
        },
        {
          name: '人脸融合',
          img: require('../assets/images/growth/list3_icon5.png')
        },
        {
          name: '计算机视觉',
          img: require('../assets/images/growth/list3_icon6.png')
        },
        {
          name: '智能推荐',
          img: require('../assets/images/growth/list3_icon7.png')
        },
        {
          name: '数据可视化',
          img: require('../assets/images/growth/list3_icon8.png')
        }
      ],
      content5FlowList: [
        {
          name: '流量效率',
          img: require('../assets/images/growth/list4_bg1.png')
        },
        {
          name: '转化效率',
          img: require('../assets/images/growth/list4_bg2.png')
        },
        {
          name: '裂变效率',
          img: require('../assets/images/growth/list4_bg3.png')
        },
        {
          name: '复购效率',
          img: require('../assets/images/growth/list4_bg4.png')
        }
      ],
      content5TitleList1: [
        '品牌：人民日报 (国家重点新闻媒体)',
        '需求：传递正能量，弘扬社会主义价值观',
        '业绩：客户案例获得中国新闻奖，最高日UV2亿'
      ],
      content5NameList1: [
        {
          name: '穿上军装照',
          img: require('../assets/images/growth/list5_bg1.png')
        },
        {
          name: '两会喊你来群聊',
          img: require('../assets/images/growth/list5_bg2.png')
        },
        {
          name: '人民日报70年',
          img: require('../assets/images/growth/list5_bg3.png')
        },
        {
          name: '重温五四',
          img: require('../assets/images/growth/list5_bg4.png')
        },
        {
          name: '一带一路',
          img: require('../assets/images/growth/list5_bg5.png')
        }
      ],
      content5TitleList2: [
        '品牌：经纬创投 创投圈的意见领袖',
        '需求：链接更多创业者，提升品牌知名度',
        '业绩：多次在创投圈内刷屏，公众号日均阅读破   万收到创投圈的欢迎'
      ],
      content5NameList2: [
        {
          name: '经纬“创”大会',
          img: require('../assets/images/growth/list6_bg1.png')
        },
        {
          name: '亿万学院',
          img: require('../assets/images/growth/list6_bg2.png')
        },
        {
          name: '经纬资讯',
          img: require('../assets/images/growth/list6_bg3.png')
        },
        {
          name: '移动社交产品经理分享会',
          img: require('../assets/images/growth/list6_bg4.png')
        },
        {
          name: '经纬BP通道',
          img: require('../assets/images/growth/list6_bg5.png')
        }
      ],
      content5NameList3: [
        {
          name: '广告投放截图',
          img: require('../assets/images/growth/list8_bg1.png')
        },
        {
          name: '每日抽奖APP',
          img: require('../assets/images/growth/list8_bg2.png')
        },
        {
          name: '罗技京东店铺',
          img: require('../assets/images/growth/list8_bg3.png')
        },
        {
          name: '京微力小程序开发者大赛',
          img: require('../assets/images/growth/list8_bg4.png')
        },
        {
          name: '用户路径图',
          img: require('../assets/images/growth/list8_bg5.png')
        }
      ],
      content6SwiperList: [
        {
          img: require('../assets/images/growth/list7_bg1.png')
        },
        {
          img: require('../assets/images/growth/list7_bg2.png')
        },
        {
          img: require('../assets/images/growth/list7_bg3.png')
        },
        {
          img: require('../assets/images/growth/list7_bg4.png')
        },
        {
          img: require('../assets/images/growth/list7_bg5.png')
        }
      ]
    }
  },
  methods: {
    changeSwiper1Handler: function (index) {
      this.swiper1.slideTo(index + 1)
    },
    changeSwiper2Handler: function (index) {
      this.swiper2.slideTo(index + 1)
    },
    changeSwiper3Handler: function (index) {
      this.swiper3.slideTo(index + 1)
    },
    changeSwiper4Handler: function (index) {
      this.swiper4.slideTo(index + 1)
    },
    changeSwiper6Handler: function (index) {
      this.swiper6.slideTo(index + 1)
    },
    initSwiper1 () {
      const _this = this
      const swiper1 = new Swiper(_this.$refs.swiper1, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        // autoplay: true,
        // pagination: {
        //   el: _this.$refs.homeSwiperPagination
        // },
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper1CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper1 = swiper1
    },
    initSwiper2 () {
      const _this = this
      const swiper2 = new Swiper(_this.$refs.swiper2, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        autoplay: true,
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper2CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper2 = swiper2
    },
    initSwiper3 () {
      const _this = this
      const swiper3 = new Swiper(_this.$refs.swiper3, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        autoplay: true,
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper3CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper3 = swiper3
    },
    initSwiper4 () {
      const _this = this
      const swiper4 = new Swiper(_this.$refs.swiper4, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        autoplay: true,
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper4CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper4 = swiper4
    },
    initSwiper5 () {
      const _this = this
      const swiper5 = new Swiper(_this.$refs.swiper5, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        autoplay: true,
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper5CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper5 = swiper5
    },
    initSwiper6 () {
      const _this = this
      const swiper6 = new Swiper(_this.$refs.swiper6, { // eslint-disable-line
        direction: 'horizontal',
        loop: true,
        autoplay: true,
        on: {
          click: function () {
            console.log(this.realIndex, '----this.realIndex ----')
          },
          slideChange: function () {
            _this.swiper6CurrentIndex = this.realIndex
          }
        }
      })
      _this.swiper6 = swiper6
    },
    joinHandler () {
      document.getElementById('contact').scrollIntoView()
    },
    showDialogHandler (index) {
      this.dialogInfo = this.contentDialogList[index]
      this.showDialog = true
    },
    closeDialogHandler () {
      this.showDialog = false
    },
    callPhoneHandler (phoneNum) {
      window.location.href = 'tel:' + phoneNum
    },
    notDo () {

    },
    // 滚动到指定元素
    scrollToDom () {
      document.getElementById('contact').scrollIntoView()
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.initSwiper1()
      this.initSwiper2()
      this.initSwiper3()
      this.initSwiper4()
      this.initSwiper5()
      this.initSwiper6()
    }.bind(this))
  }
}
</script>

<style lang="less" scoped>
@import '~swiper/css/swiper.css';
.growth {
  background-color: #F6F7F9;
  .content-title {
    width: 100%;
    height: 112px;
    background-color: #333333;
    display: flex;
    align-items: center;
    padding-right: 132px;
    box-sizing: border-box;
    .icon {
      width: 92px;
      height: 72px;
      margin-left: 40px;
    }
    .title {
      margin: 0 auto;
      color: #ffffff;
      font-size: 32px;
      font-weight: 400;
    }
  }
  .content-1 {
    width: 100%;
    height: 600px;
    position: relative;
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .btn-join {
      position: absolute;
      bottom: 0;
      left: 30%;
      right: 30%;
      height: 30%;
    }
  }
  .content-2 {
    width: 100%;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 32px;
      color: #333333;
      line-height: 44px;
      margin-top: 48px;
      align-self: center;
      font-weight: 600;
    }
    .notice {
      font-size: 24px;
      color: #999999;
      line-height: 34px;
      margin-top: 10px;
      align-self: center;
      font-weight: 400;
    }
    .list-case {
      display: flex;
      width: 700px;
      flex-wrap: wrap;
      align-self: center;
      margin-top: 28px;
      .item-case {
        width: 320px;
        height: 506px;
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        box-shadow:0px 4px 8px 0px rgba(211,223,255,1);
        background-color: #ffffff;
        margin: 0 15px 40px;
        .content-name {
          width: 100%;
          height: 80px;
          position: relative;
          .bg-name {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
          .name {
            font-size: 28px;
            line-height: 80px;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
          }
        }
        .content-core {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding-left: 32px;
          margin-top: 20px;
          box-sizing: border-box;
          .name {
            font-size: 24px;
            color: #333333;
            font-weight: 600;
            line-height: 34px;
          }
          .core-info {
            display: flex;
            margin-top: 16px;
            .core {
              font-size: 24px;
              color: #666666;
              line-height: 24px;
              font-weight: 400;
              margin-right: 20px;
            }
          }
        }
        .content-tool {
          width: 100%;
          display: flex;
          flex-direction: column;
          padding-left: 32px;
          margin-top: 24px;
          margin-bottom: 12px;
          box-sizing: border-box;
          .name {
            font-size: 24px;
            color: #333333;
            font-weight: 600;
            line-height: 34px;
          }
          .tool-info {
            display: flex;
            flex-direction: column;
            margin-top: 16px;
            .item-tool {
              display: flex;
              align-items: flex-start;
              margin-bottom: 8px;
              .icon {
                width: 24px;
                height: 24px;
                margin-top: 6px;
                margin-right: 8px;
              }
              .tool {
                max-width: 182px;
                font-size: 24px;
                color: #666666;
                font-weight: 400;
                line-height: 36px;
              }
            }
          }
        }
        .content-introduce {
          height: 68px;
          display: flex;
          align-items: center;
          margin: 0 12px;
          margin-top: auto;
          box-sizing: border-box;
          border-top: 1px solid #F4F4F4;
          .icon {
            width: 24px;
            height: 24px;
            margin-left: 20px;
            margin-right: 6px;
          }
          .introduce {
            font-size: 24px;
            color: #1B55F9;
            font-weight: 400;
          }
        }
      }
    }
  }
  .content-3 {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    .title-info {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 60px;
      .title {
        font-size: 32px;
        color: #333333;
        font-weight: 600;
        line-height:52px;
      }
    }
    .content-desc {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 20px;
      .desc {
        width: 670px;
        color: #999999;
        font-size: 24px;
        line-height: 36px;
        font-weight: 400;
      }
    }
    .list-features {
      width: 100%;
      display: flex;
      margin-top: 20px;
      padding-bottom: 60px;
      flex-wrap: wrap;
      justify-content: space-evenly;
      .item-feature {
        width: 292px;
        height: 374px;
        position: relative;
        margin-top: 40px;
        .bg-feature {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .feature-info {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          .icon {
            width: 88px;
            height: 88px;
            margin-top: 60px;
          }
          .name {
            font-size: 40px;
            color: #D5D5D5;
            line-height: 60px;
            margin-top: 46px;
          }
          .desc {
            font-size: 22px;
            color: #D5D5D5;
            line-height: 32px;
            margin-top: 8px;
            text-align: center;
          }
        }
      }
    }
  }
  .content-4 {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    margin-bottom: 58px;
    .top-bg {
      widows: 100%;
      height: 880px;
    }
    .title {
      font-size: 32px;
      color: #666666;
      margin-top: 40px;
      font-weight: 600;
      line-height: 52px;
    }
    .notice {
      font-size: 28px;
      color: #FF6523;
      margin-top: 16px;
      line-height: 36px;
    }
    .swiper2 {
      width: 466px;
      height: 730px;
      margin-top: 44px;
      .slide-item {
        width: 100%;
        height: 100%;
        .bg {
          width: 100%;
          height: 100%;
        }
      }
    }
    .swiper-notice {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 40px;
      .name {
        font-size: 32px;
        color: #666666;
        font-weight: 500;
        line-height: 52px;
      }
      .desc {
        font-size: 24px;
        color: #666666;
        font-weight: 400;
        line-height: 36px;
        margin-top: 8px;
      }
      .swiper-navs {
        display: flex;
        align-items: center;
        margin-top: 40px;
        .item-nav {
          width: 60px;
          height: 8px;
          border-radius: 5px;
          background-color: #E5E5E5;
          margin: 0 6px;
        }
        .selected {
          background-color: #FF6523;
        }
      }
    }
    .more {
      margin-top: 40px;
      margin-bottom: 60px;
    }
  }
  .content-5 {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    .content-notice1 {
      height: 300px;
    }
    .content-notice2 {
      height: 320px;
    }
    .content-notice1,
    .content-notice2 {
      width: 100%;
      position: relative;
      .notice-bg1 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .notice-bg2 {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .list-notice {
        display: flex;
        flex-direction: column;
        width: 596px;
        position: absolute;
        top: 32px;
        left: 76px;
        .notice {
          font-size: 28px;
          color: #333333;
          line-height: 44px;
          margin-bottom: 20px;
        }
      }
    }

    .swiper3, .swiper4, .swiper6 {
      width: 498px;
      height: 784px;
      margin-top: 40px;
      .slide-item {
        width: 100%;
        height: 100%;
        .bg {
          width: 100%;
          height: 100%;
        }
      }
    }
    .swiper-notice {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      .desc {
        font-size: 28px;
        color: #333333;
        line-height: 40px;
        margin-top: 20px;
      }
      .swiper-navs {
        display: flex;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 60px;
        .item-nav {
          width: 60px;
          height: 8px;
          border-radius: 5px;
          background-color:rgba(0,0,0,0.19);
          margin: 0 6px;
        }
        .selected {
          background-color: #FF6523;
        }
      }
    }
    .more {
      margin-bottom: 60px;
    }
  }
  .content-6 {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    background-color: #ffffff;
    .content-rocket {
      width: 100%;
      height: 448px;
      display: flex;
      align-items: center;
      justify-content: center;
      .rocket {
        width: 670px;
        height: 328px;
      }
    }
    .swiper5 {
      width: 100%;
      height: 648px;
      .slide-item {
        width: 100%;
        height: 100%;
        .bg {
          width: 100%;
          height: 100%;
        }
      }
    }
    .content-brand {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        font-size: 32px;
        color: #333333;
        font-weight: 600;
        line-height: 64px;
        margin-top: 60px;
      }
      .bg-brand {
        width: 620px;
        height: 1952px;
        margin-top: 28px;
        margin-bottom: 60px;
      }
    }
  }
  .content-7 {
    display: flex;
    flex-direction: column;
    width: 100%;
    .content-prize {
      width: 100%;
      height: 428px;
      position: relative;
      .bg-prize {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
      .name {
        width: 100%;
        position: absolute;
        top: 28px;
        left: 0;
        font-size: 26px;
        color: #333333;
        text-align: center;
      }
      .notice {
        width: 100%;
        position: absolute;
        top: 68px;
        left: 0;
        font-size: 24px;
        color: #999990;
        text-align: center;
      }
    }
    .content-person {
      width: 670px;
      height: 356px;
      align-self: center;
      margin: 48px 0 60px;
      display: flex;
      background-color: #ffffff;
      box-shadow:0px 8px 8px 0px rgba(142,142,142,0.13);
      .avatar {
        width: 270px;
        height: 100%;
      }
      .content-info {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        .content-top {
          display: flex;
          height: 144px;
          padding-left: 28px;
          .person-info {
            display: flex;
            flex-direction: column;
            .position {
              font-size: 24px;
              color: #333333;
              font-weight: 400;
              margin-top: 18px;
            }
            .name {
              font-size: 30px;
              color: #333333;
              font-weight: 600;
              margin-top: 14px;
              margin-bottom: 2px;
            }
            .name-en {
              font-size: 20px;
              color: #333333;
              font-weight: 400;
            }
          }
          .icon {
            width: 124px;
            height: 124px;
            margin-left: auto;
          }
        }
        .content-bottom {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: #FFFAF9;
          .notice {
            font-size: 24px;
            color: #333333;
            font-weight: 400;
            line-height: 36px;
            margin-left: 28px;
          }
        }
      }
    }
    .content-qr {
      width: 100%;
      height: 494px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #333333;
      .qr {
        width: 224px;
        height: 224px;
        margin-top: 60px;
      }
      .phone-num {
        font-size: 28px;
        color: #ffffff;
        font-weight: 400;
        line-height: 34px;
        margin-top: 12px;
        margin-bottom: 20px;
      }
      .num {
        font-size: 22px;
        color: #ffffff;
        font-weight: 400;
        line-height: 34px;
        margin-top: 20px;
        margin-bottom: 12px;
      }
      .company {
        font-size: 22px;
        color: #ffffff;
        font-weight: 400;
        line-height: 34px;
      }
    }
  }

  .btn-bg {
    width: 516px;
    height: 80px;
    border-radius: 40px;
    background:linear-gradient(270deg,rgba(255,158,73,1) 0%,rgba(255,101,35,1) 100%);
    font-size: 28px;
    color: #ffffff;
    line-height: 80px;
    font-weight: 600;
    text-align: center;
  }

  .bg-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.4);
    .content-dialog {
      width: 490px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .icon-close {
        width: 38.4px;
        height: 38.4px;
        margin-bottom: 30px;
        margin-top: -70px;
      }
      .dialog-chat {
        width: 100%;
        height: 700px;
        border-radius: 8px;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        padding: 0 32px;
        box-sizing: border-box;
        .title {
          font-size: 24px;
          color: #1B55F9;
          font-weight: 400;
          line-height: 36px;
          margin-top: 28px;
        }
        .name {
          font-size: 32px;
          color: #333333;
          font-weight: 400;
          line-height: 48px;
          margin-top: 12px;
        }
        .desc {
          font-size: 24px;
          color: #333333;
          font-weight: 400;
          line-height: 36px;
          margin-top: 28px;
        }
        .content-people {
          display: flex;
          align-items: center;
          margin-top: 24px;
          .avatar {
            width: 80px;
            height: 80px;
            margin-right: 28px;
          }
          .people-info {
            display: flex;
            flex-direction: column;
            .people-name {
              font-size: 24px;
              color: #666666;
              font-weight: 400;
              line-height: 36px;
            }
            .position {
              font-size: 24px;
              color: #666666;
              font-weight: 400;
              line-height: 36px;
            }
            .phone {
              font-size: 24px;
              color: #666666;
              font-weight: 400;
              line-height: 36px;
            }
          }
        }
        .line {
          width: 100%;
          height: 2px;
          background-color: #F4F4F4;
          margin: 24px 0;
        }
        .qr-code {
          width: 190px;
          height: 190px;
          margin-bottom: 24px;
          align-self: center;
        }
        .notice {
          font-size: 22px;
          color: #999999;
          font-weight: 400;
          line-height: 36px;
          text-align: center;
        }
      }
    }
  }
}
</style>
